module.exports = __webpack_public_path__ + "img/Mustard.1db94e55.svg";